import { isApolloError } from '@apollo/client';

export const ERRORS_TO_TRACK_IN_SENTRY = ['INVALID_ACCESS_TOKEN_ERROR'] as const;
export const ERRORS_TO_HANDLE_GLOBALLY = ['THROTTLING_ERROR', 'UPDATE_REQUIRED_ERROR'] as const;

export type HandledGlobalErrorsType = (typeof ERRORS_TO_HANDLE_GLOBALLY)[number];
export type GlobalErrorHandlerType = Record<string, () => any>;

// Each method is fulfilled with a function implementation during the app lifecycle
export const globalErrorHandler: GlobalErrorHandlerType = {
  showRateLimitedSnackbar: () => null,
};

export const isHandledGlobally = (error: unknown) => {
  if (!(error instanceof Error)) {
    return false;
  }

  if (isApolloError(error)) {
    return !!error.graphQLErrors.find(
      (gqlError) =>
        ERRORS_TO_HANDLE_GLOBALLY.includes(gqlError.extensions?.code) ||
        ERRORS_TO_HANDLE_GLOBALLY.includes(gqlError.extensions?.exception?.code),
    );
  }

  return false;
};

export const isThrottlingError = (errorCode: any): errorCode is 'THROTTLING_ERROR' => errorCode === 'THROTTLING_ERROR';
